import { appendALExamTemplate } from '@/functions/idp'
import RIC from './RIC_4'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
